import React from "react";
import DashboardOnboardedContainer from "./DashboardOnboarded";
import PrimeOnboardingNotCompleted from "./PrimeOnboardingNotCompleted";

class DashboardContainer extends React.Component {
  render() {
    if (!this.props.isPrimeOnboardingCompleted) {
      return (
        <>
          <PrimeOnboardingNotCompleted />
        </>
      );
    }
    return <DashboardOnboardedContainer />;
  }
}

export default DashboardContainer;
